module.exports = __webpack_public_path__ + "static/media/wizualizacja-134.5da3eb68.png";